import { createElement } from "react";
import "./profile-picture.less";
import {classNames} from "utils/helpers";

export type ProfilePictureSize = "Normal" | "Menu"

export default function ProfilePicture(props: {
  tagName?: keyof HTMLElementTagNameMap
  className?: string
  profilePictureUrl: string|null|undefined
  size?: ProfilePictureSize
})
{
  const { profilePictureUrl, size, className } = props

  if (typeof profilePictureUrl !== "string") return null
  
  const tagName = props.tagName || 'div'

  return createElement(tagName, {
    className: classNames('profile-picture default-shadow-on-all-sides', className, {
      'size-menu': size === "Menu",
      'size-normal': size !== "Menu"
    }),
    style: {
      backgroundImage: `url(${profilePictureUrl})`
    }
  })
}